import { api } from "./UrlPadrao";

interface BuscarMetaFilialProps {
	token: string;
	mes: string;
	ano: string;
	filial: string;
}

export interface MetaFilial {
	dia: string;
	meta: string;
	realizado: string;
	porcentualAtingido: string;
}

export const buscarMetaFilial = async ({
	token,
	mes,
	ano,
	filial,
}: BuscarMetaFilialProps): Promise<MetaFilial[]> => {
	const response = await api.get(
		`meta-filial/buscar-meta-filial/${mes}/${ano}/${filial}`,
		{
			headers: {
				Authorization: token,
			},
		},
	);
	return response.data;
};
